import CalendarRange from "../../../shared/components/CalendarRange"
import { Box, Container, Typography, useTheme, IconButton, InputLabel, TextField, Grid, Button, Tabs, Tab } from "@mui/material"
import { useNavigate, useParams } from "react-router"

import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ProgramacionComponent from "../components/scheduled/ProgramacionComponent"
import { useState, useMemo, useEffect } from "react"
import SettingsIcon from '@mui/icons-material/Settings';
import AddTaskRoundedIcon from '@mui/icons-material/AddTaskRounded';
import TareasComponent from "../components/scheduled/TareasComponent"
import SaveIcon from '@mui/icons-material/Save';
import { useScheduled } from "../../../shared/context/scheduledContext"

export default function ScheduledView() {
    const theme = useTheme();
    const navigate = useNavigate();
    const { tabActive, setTabActive, getGroupScheduledByHash } = useScheduled()
    //parametro de la url
    const { code_group } = useParams()

    const handleToBack = () => {
        navigate('/task/scheduled/')
    }


    const handleChange = (event, newValue) => {
        setTabActive(newValue)
    }


    /**
     * Obtener el grupo programado por el hash
     */
    useEffect(() => {
        const fetchAndSetData = async () => {
            if (code_group) {
                await getGroupScheduledByHash(code_group);
            }
        };
        
        fetchAndSetData();
    }, [code_group]);  


    const tabComponent = {
        0: <ProgramacionComponent />,
        1: <TareasComponent />
    }


    const tabContainer = useMemo(() => {
        return tabComponent[tabActive]
    }, [tabActive])

    return (
        <Container maxWidth="xl">
            {/* <CalendarRange /> */}

            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '20px'
            }}>

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '0px'
                }}>
                    <IconButton
                        onClick={handleToBack}
                        sx={{
                            borderRadius: '12px',
                            padding: '8px',
                            backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)',
                            transition: 'all 0.2s',
                            "&:hover": {
                                backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
                                transform: 'translateY(-2px)'
                            }
                        }}
                    >
                        <ArrowBackIcon />
                    </IconButton>


                </Box>
                    


                </Box>

                <Box sx={{ p: { xs: 0.5, md: 1 }, borderRadius: '10px', backgroundColor: theme.palette.background.paper, boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)' }}>

                    <Tabs
                        value={tabActive}
                        onChange={handleChange}
                        sx={{
                            minHeight: '48px',
                            '& .MuiTabs-indicator': {
                                height: '3px',
                                borderRadius: '1.5px',
                                backgroundColor: theme.palette.primary.main
                            },
                            '& .MuiTab-root': {
                                minHeight: '48px',
                                color: theme.palette.text.secondary,
                                transition: 'all 0.2s',
                                opacity: 0.7,
                                '&.Mui-selected': {
                                    color: theme.palette.primary.main,
                                    opacity: 1,
                                    fontWeight: 600
                                },
                                '&:hover': {
                                    opacity: 1,
                                    backgroundColor: 'transparent'
                                }
                            }
                        }}
                    >
                        <Tab
                            label={
                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    transition: 'all 0.2s'
                                }}>
                                    <SettingsIcon sx={{
                                        width: '20px',
                                        height: '20px',
                                        transition: 'transform 0.2s',
                                        '.Mui-selected &': {
                                            transform: 'rotate(90deg)'
                                        }
                                    }} />
                                    <Typography sx={{
                                        fontWeight: 500,
                                        fontSize: '14px'
                                    }}>
                                        Programación
                                    </Typography>
                                </Box>
                            }
                        />
                        <Tab
                            disabled={!code_group}
                            label={
                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px'
                                }}>
                                    <AddTaskRoundedIcon sx={{
                                        width: '20px',
                                        height: '20px',
                                        transition: 'transform 0.2s',
                                        '.Mui-selected &': {
                                            transform: 'scale(1.2)'
                                        }
                                    }} />
                                    <Typography sx={{
                                        fontWeight: 500,
                                        fontSize: '14px'
                                    }}>
                                        Tareas
                                    </Typography>
                                </Box>
                            }
                        />
                    </Tabs>

                    {tabContainer}



                </Box>

        </Container>
    )
}